module.exports = __webpack_public_path__ + "static/media/17.0d2b112d.mp3";